module.exports = __webpack_public_path__ + "static/frenchfries-d8c7731101f5e88510ed6429afe9c575.woff";